export const countries = {
    LIST: [
        {
            num_code: '4',
            code: 'AF',
            alpha_3_code: 'AFG',
            en_short_name: 'Afghanistan',
            name: 'Afghan',
        },
        {
            num_code: '248',
            code: 'AX',
            alpha_3_code: 'ALA',
            en_short_name: '\u00c5land Islands',
            name: '\u00c5land Island',
        },
        {
            num_code: '8',
            code: 'AL',
            alpha_3_code: 'ALB',
            en_short_name: 'Albania',
            name: 'Albanian',
        },
        {
            num_code: '12',
            code: 'DZ',
            alpha_3_code: 'DZA',
            en_short_name: 'Algeria',
            name: 'Algerian',
        },
        {
            num_code: '16',
            code: 'AS',
            alpha_3_code: 'ASM',
            en_short_name: 'American Samoa',
            name: 'American Samoan',
        },
        {
            num_code: '20',
            code: 'AD',
            alpha_3_code: 'AND',
            en_short_name: 'Andorra',
            name: 'Andorran',
        },
        {
            num_code: '24',
            code: 'AO',
            alpha_3_code: 'AGO',
            en_short_name: 'Angola',
            name: 'Angolan',
        },
        {
            num_code: '660',
            code: 'AI',
            alpha_3_code: 'AIA',
            en_short_name: 'Anguilla',
            name: 'Anguillan',
        },
        {
            num_code: '10',
            code: 'AQ',
            alpha_3_code: 'ATA',
            en_short_name: 'Antarctica',
            name: 'Antarctic',
        },
        {
            num_code: '28',
            code: 'AG',
            alpha_3_code: 'ATG',
            en_short_name: 'Antigua and Barbuda',
            name: 'Antiguan or Barbudan',
        },
        {
            num_code: '32',
            code: 'AR',
            alpha_3_code: 'ARG',
            en_short_name: 'Argentina',
            name: 'Argentine',
        },
        {
            num_code: '51',
            code: 'AM',
            alpha_3_code: 'ARM',
            en_short_name: 'Armenia',
            name: 'Armenian',
        },
        {
            num_code: '533',
            code: 'AW',
            alpha_3_code: 'ABW',
            en_short_name: 'Aruba',
            name: 'Aruban',
        },
        {
            num_code: '36',
            code: 'AU',
            alpha_3_code: 'AUS',
            en_short_name: 'Australia',
            name: 'Australian',
        },
        {
            num_code: '40',
            code: 'AT',
            alpha_3_code: 'AUT',
            en_short_name: 'Austria',
            name: 'Austrian',
        },
        {
            num_code: '31',
            code: 'AZ',
            alpha_3_code: 'AZE',
            en_short_name: 'Azerbaijan',
            name: 'Azerbaijani, Azeri',
        },
        {
            num_code: '44',
            code: 'BS',
            alpha_3_code: 'BHS',
            en_short_name: 'Bahamas',
            name: 'Bahamian',
        },
        {
            num_code: '48',
            code: 'BH',
            alpha_3_code: 'BHR',
            en_short_name: 'Bahrain',
            name: 'Bahraini',
        },
        {
            num_code: '50',
            code: 'BD',
            alpha_3_code: 'BGD',
            en_short_name: 'Bangladesh',
            name: 'Bangladeshi',
        },
        {
            num_code: '52',
            code: 'BB',
            alpha_3_code: 'BRB',
            en_short_name: 'Barbados',
            name: 'Barbadian',
        },
        {
            num_code: '112',
            code: 'BY',
            alpha_3_code: 'BLR',
            en_short_name: 'Belarus',
            name: 'Belarusian',
        },
        {
            num_code: '56',
            code: 'BE',
            alpha_3_code: 'BEL',
            en_short_name: 'Belgium',
            name: 'Belgian',
        },
        {
            num_code: '84',
            code: 'BZ',
            alpha_3_code: 'BLZ',
            en_short_name: 'Belize',
            name: 'Belizean',
        },
        {
            num_code: '204',
            code: 'BJ',
            alpha_3_code: 'BEN',
            en_short_name: 'Benin',
            name: 'Beninese, Beninois',
        },
        {
            num_code: '60',
            code: 'BM',
            alpha_3_code: 'BMU',
            en_short_name: 'Bermuda',
            name: 'Bermudian, Bermudan',
        },
        {
            num_code: '64',
            code: 'BT',
            alpha_3_code: 'BTN',
            en_short_name: 'Bhutan',
            name: 'Bhutanese',
        },
        {
            num_code: '68',
            code: 'BO',
            alpha_3_code: 'BOL',
            en_short_name: 'Bolivia (Plurinational State of)',
            name: 'Bolivian',
        },
        {
            num_code: '535',
            code: 'BQ',
            alpha_3_code: 'BES',
            en_short_name: 'Bonaire, Sint Eustatius and Saba',
            name: 'Bonaire',
        },
        {
            num_code: '70',
            code: 'BA',
            alpha_3_code: 'BIH',
            en_short_name: 'Bosnia and Herzegovina',
            name: 'Bosnian or Herzegovinian',
        },
        {
            num_code: '72',
            code: 'BW',
            alpha_3_code: 'BWA',
            en_short_name: 'Botswana',
            name: 'Motswana, Botswanan',
        },
        {
            num_code: '74',
            code: 'BV',
            alpha_3_code: 'BVT',
            en_short_name: 'Bouvet Island',
            name: 'Bouvet Island',
        },
        {
            num_code: '76',
            code: 'BR',
            alpha_3_code: 'BRA',
            en_short_name: 'Brazil',
            name: 'Brazilian',
        },
        {
            num_code: '86',
            code: 'IO',
            alpha_3_code: 'IOT',
            en_short_name: 'British Indian Ocean Territory',
            name: 'BIOT',
        },
        {
            num_code: '96',
            code: 'BN',
            alpha_3_code: 'BRN',
            en_short_name: 'Brunei Darussalam',
            name: 'Bruneian',
        },
        {
            num_code: '100',
            code: 'BG',
            alpha_3_code: 'BGR',
            en_short_name: 'Bulgaria',
            name: 'Bulgarian',
        },
        {
            num_code: '854',
            code: 'BF',
            alpha_3_code: 'BFA',
            en_short_name: 'Burkina Faso',
            name: 'Burkinab\u00e9',
        },
        {
            num_code: '108',
            code: 'BI',
            alpha_3_code: 'BDI',
            en_short_name: 'Burundi',
            name: 'Burundian',
        },
        {
            num_code: '132',
            code: 'CV',
            alpha_3_code: 'CPV',
            en_short_name: 'Cabo Verde',
            name: 'Cabo Verdean',
        },
        {
            num_code: '116',
            code: 'KH',
            alpha_3_code: 'KHM',
            en_short_name: 'Cambodia',
            name: 'Cambodian',
        },
        {
            num_code: '120',
            code: 'CM',
            alpha_3_code: 'CMR',
            en_short_name: 'Cameroon',
            name: 'Cameroonian',
        },
        {
            num_code: '124',
            code: 'CA',
            alpha_3_code: 'CAN',
            en_short_name: 'Canada',
            name: 'Canadian',
        },
        {
            num_code: '136',
            code: 'KY',
            alpha_3_code: 'CYM',
            en_short_name: 'Cayman Islands',
            name: 'Caymanian',
        },
        {
            num_code: '140',
            code: 'CF',
            alpha_3_code: 'CAF',
            en_short_name: 'Central African Republic',
            name: 'Central African',
        },
        {
            num_code: '148',
            code: 'TD',
            alpha_3_code: 'TCD',
            en_short_name: 'Chad',
            name: 'Chadian',
        },
        {
            num_code: '152',
            code: 'CL',
            alpha_3_code: 'CHL',
            en_short_name: 'Chile',
            name: 'Chilean',
        },
        {
            num_code: '156',
            code: 'CN',
            alpha_3_code: 'CHN',
            en_short_name: 'China',
            name: 'Chinese',
        },
        {
            num_code: '162',
            code: 'CX',
            alpha_3_code: 'CXR',
            en_short_name: 'Christmas Island',
            name: 'Christmas Island',
        },
        {
            num_code: '166',
            code: 'CC',
            alpha_3_code: 'CCK',
            en_short_name: 'Cocos (Keeling) Islands',
            name: 'Cocos Island',
        },
        {
            num_code: '170',
            code: 'CO',
            alpha_3_code: 'COL',
            en_short_name: 'Colombia',
            name: 'Colombian',
        },
        {
            num_code: '174',
            code: 'KM',
            alpha_3_code: 'COM',
            en_short_name: 'Comoros',
            name: 'Comoran, Comorian',
        },
        {
            num_code: '178',
            code: 'CG',
            alpha_3_code: 'COG',
            en_short_name: 'Congo (Republic of the)',
            name: 'Congolese',
        },
        {
            num_code: '180',
            code: 'CD',
            alpha_3_code: 'COD',
            en_short_name: 'Congo (Democratic Republic of the)',
            name: 'Congolese',
        },
        {
            num_code: '184',
            code: 'CK',
            alpha_3_code: 'COK',
            en_short_name: 'Cook Islands',
            name: 'Cook Island',
        },
        {
            num_code: '188',
            code: 'CR',
            alpha_3_code: 'CRI',
            en_short_name: 'Costa Rica',
            name: 'Costa Rican',
        },
        {
            num_code: '384',
            code: 'CI',
            alpha_3_code: 'CIV',
            en_short_name: "C\u00f4te d'Ivoire",
            name: 'Ivorian',
        },
        {
            num_code: '191',
            code: 'HR',
            alpha_3_code: 'HRV',
            en_short_name: 'Croatia',
            name: 'Croatian',
        },
        {
            num_code: '192',
            code: 'CU',
            alpha_3_code: 'CUB',
            en_short_name: 'Cuba',
            name: 'Cuban',
        },
        {
            num_code: '531',
            code: 'CW',
            alpha_3_code: 'CUW',
            en_short_name: 'Cura\u00e7ao',
            name: 'Cura\u00e7aoan',
        },
        {
            num_code: '196',
            code: 'CY',
            alpha_3_code: 'CYP',
            en_short_name: 'Cyprus',
            name: 'Cypriot',
        },
        {
            num_code: '203',
            code: 'CZ',
            alpha_3_code: 'CZE',
            en_short_name: 'Czech Republic',
            name: 'Czech',
        },
        {
            num_code: '208',
            code: 'DK',
            alpha_3_code: 'DNK',
            en_short_name: 'Denmark',
            name: 'Danish',
        },
        {
            num_code: '262',
            code: 'DJ',
            alpha_3_code: 'DJI',
            en_short_name: 'Djibouti',
            name: 'Djiboutian',
        },
        {
            num_code: '212',
            code: 'DM',
            alpha_3_code: 'DMA',
            en_short_name: 'Dominica',
            name: 'Dominican',
        },
        {
            num_code: '214',
            code: 'DO',
            alpha_3_code: 'DOM',
            en_short_name: 'Dominican Republic',
            name: 'Dominican',
        },
        {
            num_code: '218',
            code: 'EC',
            alpha_3_code: 'ECU',
            en_short_name: 'Ecuador',
            name: 'Ecuadorian',
        },
        {
            num_code: '818',
            code: 'EG',
            alpha_3_code: 'EGY',
            en_short_name: 'Egypt',
            name: 'Egyptian',
        },
        {
            num_code: '222',
            code: 'SV',
            alpha_3_code: 'SLV',
            en_short_name: 'El Salvador',
            name: 'Salvadoran',
        },
        {
            num_code: '226',
            code: 'GQ',
            alpha_3_code: 'GNQ',
            en_short_name: 'Equatorial Guinea',
            name: 'Equatorial Guinean, Equatoguinean',
        },
        {
            num_code: '232',
            code: 'ER',
            alpha_3_code: 'ERI',
            en_short_name: 'Eritrea',
            name: 'Eritrean',
        },
        {
            num_code: '233',
            code: 'EE',
            alpha_3_code: 'EST',
            en_short_name: 'Estonia',
            name: 'Estonian',
        },
        {
            num_code: '231',
            code: 'ET',
            alpha_3_code: 'ETH',
            en_short_name: 'Ethiopia',
            name: 'Ethiopian',
        },
        {
            num_code: '238',
            code: 'FK',
            alpha_3_code: 'FLK',
            en_short_name: 'Falkland Islands (Malvinas)',
            name: 'Falkland Island',
        },
        {
            num_code: '234',
            code: 'FO',
            alpha_3_code: 'FRO',
            en_short_name: 'Faroe Islands',
            name: 'Faroese',
        },
        {
            num_code: '242',
            code: 'FJ',
            alpha_3_code: 'FJI',
            en_short_name: 'Fiji',
            name: 'Fijian',
        },
        {
            num_code: '246',
            code: 'FI',
            alpha_3_code: 'FIN',
            en_short_name: 'Finland',
            name: 'Finnish',
        },
        {
            num_code: '250',
            code: 'FR',
            alpha_3_code: 'FRA',
            en_short_name: 'France',
            name: 'French',
        },
        {
            num_code: '254',
            code: 'GF',
            alpha_3_code: 'GUF',
            en_short_name: 'French Guiana',
            name: 'French Guianese',
        },
        {
            num_code: '258',
            code: 'PF',
            alpha_3_code: 'PYF',
            en_short_name: 'French Polynesia',
            name: 'French Polynesian',
        },
        {
            num_code: '260',
            code: 'TF',
            alpha_3_code: 'ATF',
            en_short_name: 'French Southern Territories',
            name: 'French Southern Territories',
        },
        {
            num_code: '266',
            code: 'GA',
            alpha_3_code: 'GAB',
            en_short_name: 'Gabon',
            name: 'Gabonese',
        },
        {
            num_code: '270',
            code: 'GM',
            alpha_3_code: 'GMB',
            en_short_name: 'Gambia',
            name: 'Gambian',
        },
        {
            num_code: '268',
            code: 'GE',
            alpha_3_code: 'GEO',
            en_short_name: 'Georgia',
            name: 'Georgian',
        },
        {
            num_code: '276',
            code: 'DE',
            alpha_3_code: 'DEU',
            en_short_name: 'Germany',
            name: 'German',
        },
        {
            num_code: '288',
            code: 'GH',
            alpha_3_code: 'GHA',
            en_short_name: 'Ghana',
            name: 'Ghanaian',
        },
        {
            num_code: '292',
            code: 'GI',
            alpha_3_code: 'GIB',
            en_short_name: 'Gibraltar',
            name: 'Gibraltar',
        },
        {
            num_code: '300',
            code: 'GR',
            alpha_3_code: 'GRC',
            en_short_name: 'Greece',
            name: 'Greek, Hellenic',
        },
        {
            num_code: '304',
            code: 'GL',
            alpha_3_code: 'GRL',
            en_short_name: 'Greenland',
            name: 'Greenlandic',
        },
        {
            num_code: '308',
            code: 'GD',
            alpha_3_code: 'GRD',
            en_short_name: 'Grenada',
            name: 'Grenadian',
        },
        {
            num_code: '312',
            code: 'GP',
            alpha_3_code: 'GLP',
            en_short_name: 'Guadeloupe',
            name: 'Guadeloupe',
        },
        {
            num_code: '316',
            code: 'GU',
            alpha_3_code: 'GUM',
            en_short_name: 'Guam',
            name: 'Guamanian, Guambat',
        },
        {
            num_code: '320',
            code: 'GT',
            alpha_3_code: 'GTM',
            en_short_name: 'Guatemala',
            name: 'Guatemalan',
        },
        {
            num_code: '831',
            code: 'GG',
            alpha_3_code: 'GGY',
            en_short_name: 'Guernsey',
            name: 'Channel Island',
        },
        {
            num_code: '324',
            code: 'GN',
            alpha_3_code: 'GIN',
            en_short_name: 'Guinea',
            name: 'Guinean',
        },
        {
            num_code: '624',
            code: 'GW',
            alpha_3_code: 'GNB',
            en_short_name: 'Guinea-Bissau',
            name: 'Bissau-Guinean',
        },
        {
            num_code: '328',
            code: 'GY',
            alpha_3_code: 'GUY',
            en_short_name: 'Guyana',
            name: 'Guyanese',
        },
        {
            num_code: '332',
            code: 'HT',
            alpha_3_code: 'HTI',
            en_short_name: 'Haiti',
            name: 'Haitian',
        },
        {
            num_code: '334',
            code: 'HM',
            alpha_3_code: 'HMD',
            en_short_name: 'Heard Island and McDonald Islands',
            name: 'Heard Island or McDonald Islands',
        },
        {
            num_code: '336',
            code: 'VA',
            alpha_3_code: 'VAT',
            en_short_name: 'Vatican City State',
            name: 'Vatican',
        },
        {
            num_code: '340',
            code: 'HN',
            alpha_3_code: 'HND',
            en_short_name: 'Honduras',
            name: 'Honduran',
        },
        {
            num_code: '344',
            code: 'HK',
            alpha_3_code: 'HKG',
            en_short_name: 'Hong Kong',
            name: 'Hong Kong, Hong Kongese',
        },
        {
            num_code: '348',
            code: 'HU',
            alpha_3_code: 'HUN',
            en_short_name: 'Hungary',
            name: 'Hungarian, Magyar',
        },
        {
            num_code: '352',
            code: 'IS',
            alpha_3_code: 'ISL',
            en_short_name: 'Iceland',
            name: 'Icelandic',
        },
        {
            num_code: '356',
            code: 'IN',
            alpha_3_code: 'IND',
            en_short_name: 'India',
            name: 'Indian',
        },
        {
            num_code: '360',
            code: 'ID',
            alpha_3_code: 'IDN',
            en_short_name: 'Indonesia',
            name: 'Indonesian',
        },
        {
            num_code: '364',
            code: 'IR',
            alpha_3_code: 'IRN',
            en_short_name: 'Iran',
            name: 'Iranian, Persian',
        },
        {
            num_code: '368',
            code: 'IQ',
            alpha_3_code: 'IRQ',
            en_short_name: 'Iraq',
            name: 'Iraqi',
        },
        {
            num_code: '372',
            code: 'IE',
            alpha_3_code: 'IRL',
            en_short_name: 'Ireland',
            name: 'Irish',
        },
        {
            num_code: '833',
            code: 'IM',
            alpha_3_code: 'IMN',
            en_short_name: 'Isle of Man',
            name: 'Manx',
        },
        {
            num_code: '376',
            code: 'IL',
            alpha_3_code: 'ISR',
            en_short_name: 'Israel',
            name: 'Israeli',
        },
        {
            num_code: '380',
            code: 'IT',
            alpha_3_code: 'ITA',
            en_short_name: 'Italy',
            name: 'Italian',
        },
        {
            num_code: '388',
            code: 'JM',
            alpha_3_code: 'JAM',
            en_short_name: 'Jamaica',
            name: 'Jamaican',
        },
        {
            num_code: '392',
            code: 'JP',
            alpha_3_code: 'JPN',
            en_short_name: 'Japan',
            name: 'Japanese',
        },
        {
            num_code: '832',
            code: 'JE',
            alpha_3_code: 'JEY',
            en_short_name: 'Jersey',
            name: 'Channel Island',
        },
        {
            num_code: '400',
            code: 'JO',
            alpha_3_code: 'JOR',
            en_short_name: 'Jordan',
            name: 'Jordanian',
        },
        {
            num_code: '398',
            code: 'KZ',
            alpha_3_code: 'KAZ',
            en_short_name: 'Kazakhstan',
            name: 'Kazakhstani, Kazakh',
        },
        {
            num_code: '404',
            code: 'KE',
            alpha_3_code: 'KEN',
            en_short_name: 'Kenya',
            name: 'Kenyan',
        },
        {
            num_code: '296',
            code: 'KI',
            alpha_3_code: 'KIR',
            en_short_name: 'Kiribati',
            name: 'I-Kiribati',
        },
        {
            num_code: '408',
            code: 'KP',
            alpha_3_code: 'PRK',
            en_short_name: "Korea (Democratic People's Republic of)",
            name: 'North Korean',
        },
        {
            num_code: '410',
            code: 'KR',
            alpha_3_code: 'KOR',
            en_short_name: 'Korea (Republic of)',
            name: 'South Korean',
        },
        {
            num_code: '414',
            code: 'KW',
            alpha_3_code: 'KWT',
            en_short_name: 'Kuwait',
            name: 'Kuwaiti',
        },
        {
            num_code: '417',
            code: 'KG',
            alpha_3_code: 'KGZ',
            en_short_name: 'Kyrgyzstan',
            name: 'Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz',
        },
        {
            num_code: '418',
            code: 'LA',
            alpha_3_code: 'LAO',
            en_short_name: "Lao People's Democratic Republic",
            name: 'Lao, Laotian',
        },
        {
            num_code: '428',
            code: 'LV',
            alpha_3_code: 'LVA',
            en_short_name: 'Latvia',
            name: 'Latvian',
        },
        {
            num_code: '422',
            code: 'LB',
            alpha_3_code: 'LBN',
            en_short_name: 'Lebanon',
            name: 'Lebanese',
        },
        {
            num_code: '426',
            code: 'LS',
            alpha_3_code: 'LSO',
            en_short_name: 'Lesotho',
            name: 'Basotho',
        },
        {
            num_code: '430',
            code: 'LR',
            alpha_3_code: 'LBR',
            en_short_name: 'Liberia',
            name: 'Liberian',
        },
        {
            num_code: '434',
            code: 'LY',
            alpha_3_code: 'LBY',
            en_short_name: 'Libya',
            name: 'Libyan',
        },
        {
            num_code: '438',
            code: 'LI',
            alpha_3_code: 'LIE',
            en_short_name: 'Liechtenstein',
            name: 'Liechtenstein',
        },
        {
            num_code: '440',
            code: 'LT',
            alpha_3_code: 'LTU',
            en_short_name: 'Lithuania',
            name: 'Lithuanian',
        },
        {
            num_code: '442',
            code: 'LU',
            alpha_3_code: 'LUX',
            en_short_name: 'Luxembourg',
            name: 'Luxembourg, Luxembourgish',
        },
        {
            num_code: '446',
            code: 'MO',
            alpha_3_code: 'MAC',
            en_short_name: 'Macao',
            name: 'Macanese, Chinese',
        },
        {
            num_code: '807',
            code: 'MK',
            alpha_3_code: 'MKD',
            en_short_name: 'Macedonia (the former Yugoslav Republic of)',
            name: 'Macedonian',
        },
        {
            num_code: '450',
            code: 'MG',
            alpha_3_code: 'MDG',
            en_short_name: 'Madagascar',
            name: 'Malagasy',
        },
        {
            num_code: '454',
            code: 'MW',
            alpha_3_code: 'MWI',
            en_short_name: 'Malawi',
            name: 'Malawian',
        },
        {
            num_code: '458',
            code: 'MY',
            alpha_3_code: 'MYS',
            en_short_name: 'Malaysia',
            name: 'Malaysian',
        },
        {
            num_code: '462',
            code: 'MV',
            alpha_3_code: 'MDV',
            en_short_name: 'Maldives',
            name: 'Maldivian',
        },
        {
            num_code: '466',
            code: 'ML',
            alpha_3_code: 'MLI',
            en_short_name: 'Mali',
            name: 'Malian, Malinese',
        },
        {
            num_code: '470',
            code: 'MT',
            alpha_3_code: 'MLT',
            en_short_name: 'Malta',
            name: 'Maltese',
        },
        {
            num_code: '584',
            code: 'MH',
            alpha_3_code: 'MHL',
            en_short_name: 'Marshall Islands',
            name: 'Marshallese',
        },
        {
            num_code: '474',
            code: 'MQ',
            alpha_3_code: 'MTQ',
            en_short_name: 'Martinique',
            name: 'Martiniquais, Martinican',
        },
        {
            num_code: '478',
            code: 'MR',
            alpha_3_code: 'MRT',
            en_short_name: 'Mauritania',
            name: 'Mauritanian',
        },
        {
            num_code: '480',
            code: 'MU',
            alpha_3_code: 'MUS',
            en_short_name: 'Mauritius',
            name: 'Mauritian',
        },
        {
            num_code: '175',
            code: 'YT',
            alpha_3_code: 'MYT',
            en_short_name: 'Mayotte',
            name: 'Mahoran',
        },
        {
            num_code: '484',
            code: 'MX',
            alpha_3_code: 'MEX',
            en_short_name: 'Mexico',
            name: 'Mexican',
        },
        {
            num_code: '583',
            code: 'FM',
            alpha_3_code: 'FSM',
            en_short_name: 'Micronesia (Federated States of)',
            name: 'Micronesian',
        },
        {
            num_code: '498',
            code: 'MD',
            alpha_3_code: 'MDA',
            en_short_name: 'Moldova (Republic of)',
            name: 'Moldovan',
        },
        {
            num_code: '492',
            code: 'MC',
            alpha_3_code: 'MCO',
            en_short_name: 'Monaco',
            name: 'Mon\u00e9gasque, Monacan',
        },
        {
            num_code: '496',
            code: 'MN',
            alpha_3_code: 'MNG',
            en_short_name: 'Mongolia',
            name: 'Mongolian',
        },
        {
            num_code: '499',
            code: 'ME',
            alpha_3_code: 'MNE',
            en_short_name: 'Montenegro',
            name: 'Montenegrin',
        },
        {
            num_code: '500',
            code: 'MS',
            alpha_3_code: 'MSR',
            en_short_name: 'Montserrat',
            name: 'Montserratian',
        },
        {
            num_code: '504',
            code: 'MA',
            alpha_3_code: 'MAR',
            en_short_name: 'Morocco',
            name: 'Moroccan',
        },
        {
            num_code: '508',
            code: 'MZ',
            alpha_3_code: 'MOZ',
            en_short_name: 'Mozambique',
            name: 'Mozambican',
        },
        {
            num_code: '104',
            code: 'MM',
            alpha_3_code: 'MMR',
            en_short_name: 'Myanmar',
            name: 'Burmese',
        },
        {
            num_code: '516',
            code: 'NA',
            alpha_3_code: 'NAM',
            en_short_name: 'Namibia',
            name: 'Namibian',
        },
        {
            num_code: '520',
            code: 'NR',
            alpha_3_code: 'NRU',
            en_short_name: 'Nauru',
            name: 'Nauruan',
        },
        {
            num_code: '524',
            code: 'NP',
            alpha_3_code: 'NPL',
            en_short_name: 'Nepal',
            name: 'Nepali, Nepalese',
        },
        {
            num_code: '528',
            code: 'NL',
            alpha_3_code: 'NLD',
            en_short_name: 'Netherlands',
            name: 'Dutch, Netherlandic',
        },
        {
            num_code: '540',
            code: 'NC',
            alpha_3_code: 'NCL',
            en_short_name: 'New Caledonia',
            name: 'New Caledonian',
        },
        {
            num_code: '554',
            code: 'NZ',
            alpha_3_code: 'NZL',
            en_short_name: 'New Zealand',
            name: 'New Zealand, NZ',
        },
        {
            num_code: '558',
            code: 'NI',
            alpha_3_code: 'NIC',
            en_short_name: 'Nicaragua',
            name: 'Nicaraguan',
        },
        {
            num_code: '562',
            code: 'NE',
            alpha_3_code: 'NER',
            en_short_name: 'Niger',
            name: 'Nigerien',
        },
        {
            num_code: '566',
            code: 'NG',
            alpha_3_code: 'NGA',
            en_short_name: 'Nigeria',
            name: 'Nigerian',
        },
        {
            num_code: '570',
            code: 'NU',
            alpha_3_code: 'NIU',
            en_short_name: 'Niue',
            name: 'Niuean',
        },
        {
            num_code: '574',
            code: 'NF',
            alpha_3_code: 'NFK',
            en_short_name: 'Norfolk Island',
            name: 'Norfolk Island',
        },
        {
            num_code: '580',
            code: 'MP',
            alpha_3_code: 'MNP',
            en_short_name: 'Northern Mariana Islands',
            name: 'Northern Marianan',
        },
        {
            num_code: '578',
            code: 'NO',
            alpha_3_code: 'NOR',
            en_short_name: 'Norway',
            name: 'Norwegian',
        },
        {
            num_code: '512',
            code: 'OM',
            alpha_3_code: 'OMN',
            en_short_name: 'Oman',
            name: 'Omani',
        },
        {
            num_code: '586',
            code: 'PK',
            alpha_3_code: 'PAK',
            en_short_name: 'Pakistan',
            name: 'Pakistani',
        },
        {
            num_code: '585',
            code: 'PW',
            alpha_3_code: 'PLW',
            en_short_name: 'Palau',
            name: 'Palauan',
        },
        {
            num_code: '275',
            code: 'PS',
            alpha_3_code: 'PSE',
            en_short_name: 'Palestine, State of',
            name: 'Palestinian',
        },
        {
            num_code: '591',
            code: 'PA',
            alpha_3_code: 'PAN',
            en_short_name: 'Panama',
            name: 'Panamanian',
        },
        {
            num_code: '598',
            code: 'PG',
            alpha_3_code: 'PNG',
            en_short_name: 'Papua New Guinea',
            name: 'Papua New Guinean, Papuan',
        },
        {
            num_code: '600',
            code: 'PY',
            alpha_3_code: 'PRY',
            en_short_name: 'Paraguay',
            name: 'Paraguayan',
        },
        {
            num_code: '604',
            code: 'PE',
            alpha_3_code: 'PER',
            en_short_name: 'Peru',
            name: 'Peruvian',
        },
        {
            num_code: '608',
            code: 'PH',
            alpha_3_code: 'PHL',
            en_short_name: 'Philippines',
            name: 'Philippine, Filipino',
        },
        {
            num_code: '612',
            code: 'PN',
            alpha_3_code: 'PCN',
            en_short_name: 'Pitcairn',
            name: 'Pitcairn Island',
        },
        {
            num_code: '616',
            code: 'PL',
            alpha_3_code: 'POL',
            en_short_name: 'Poland',
            name: 'Polish',
        },
        {
            num_code: '620',
            code: 'PT',
            alpha_3_code: 'PRT',
            en_short_name: 'Portugal',
            name: 'Portuguese',
        },
        {
            num_code: '630',
            code: 'PR',
            alpha_3_code: 'PRI',
            en_short_name: 'Puerto Rico',
            name: 'Puerto Rican',
        },
        {
            num_code: '634',
            code: 'QA',
            alpha_3_code: 'QAT',
            en_short_name: 'Qatar',
            name: 'Qatari',
        },
        {
            num_code: '638',
            code: 'RE',
            alpha_3_code: 'REU',
            en_short_name: 'R\u00e9union',
            name: 'R\u00e9unionese, R\u00e9unionnais',
        },
        {
            num_code: '642',
            code: 'RO',
            alpha_3_code: 'ROU',
            en_short_name: 'Romania',
            name: 'Romanian',
        },
        {
            num_code: '643',
            code: 'RU',
            alpha_3_code: 'RUS',
            en_short_name: 'Russian Federation',
            name: 'Russian',
        },
        {
            num_code: '646',
            code: 'RW',
            alpha_3_code: 'RWA',
            en_short_name: 'Rwanda',
            name: 'Rwandan',
        },
        {
            num_code: '652',
            code: 'BL',
            alpha_3_code: 'BLM',
            en_short_name: 'Saint Barth\u00e9lemy',
            name: 'Barth\u00e9lemois',
        },
        {
            num_code: '654',
            code: 'SH',
            alpha_3_code: 'SHN',
            en_short_name: 'Saint Helena, Ascension and Tristan da Cunha',
            name: 'Saint Helenian',
        },
        {
            num_code: '659',
            code: 'KN',
            alpha_3_code: 'KNA',
            en_short_name: 'Saint Kitts and Nevis',
            name: 'Kittitian or Nevisian',
        },
        {
            num_code: '662',
            code: 'LC',
            alpha_3_code: 'LCA',
            en_short_name: 'Saint Lucia',
            name: 'Saint Lucian',
        },
        {
            num_code: '663',
            code: 'MF',
            alpha_3_code: 'MAF',
            en_short_name: 'Saint Martin (French part)',
            name: 'Saint-Martinoise',
        },
        {
            num_code: '666',
            code: 'PM',
            alpha_3_code: 'SPM',
            en_short_name: 'Saint Pierre and Miquelon',
            name: 'Saint-Pierrais or Miquelonnais',
        },
        {
            num_code: '670',
            code: 'VC',
            alpha_3_code: 'VCT',
            en_short_name: 'Saint Vincent and the Grenadines',
            name: 'Saint Vincentian, Vincentian',
        },
        {
            num_code: '882',
            code: 'WS',
            alpha_3_code: 'WSM',
            en_short_name: 'Samoa',
            name: 'Samoan',
        },
        {
            num_code: '674',
            code: 'SM',
            alpha_3_code: 'SMR',
            en_short_name: 'San Marino',
            name: 'Sammarinese',
        },
        {
            num_code: '678',
            code: 'ST',
            alpha_3_code: 'STP',
            en_short_name: 'Sao Tome and Principe',
            name: 'S\u00e3o Tom\u00e9an',
        },
        {
            num_code: '682',
            code: 'SA',
            alpha_3_code: 'SAU',
            en_short_name: 'Saudi Arabia',
            name: 'Saudi, Saudi Arabian',
        },
        {
            num_code: '686',
            code: 'SN',
            alpha_3_code: 'SEN',
            en_short_name: 'Senegal',
            name: 'Senegalese',
        },
        {
            num_code: '688',
            code: 'RS',
            alpha_3_code: 'SRB',
            en_short_name: 'Serbia',
            name: 'Serbian',
        },
        {
            num_code: '690',
            code: 'SC',
            alpha_3_code: 'SYC',
            en_short_name: 'Seychelles',
            name: 'Seychellois',
        },
        {
            num_code: '694',
            code: 'SL',
            alpha_3_code: 'SLE',
            en_short_name: 'Sierra Leone',
            name: 'Sierra Leonean',
        },
        {
            num_code: '702',
            code: 'SG',
            alpha_3_code: 'SGP',
            en_short_name: 'Singapore',
            name: 'Singaporean',
        },
        {
            num_code: '534',
            code: 'SX',
            alpha_3_code: 'SXM',
            en_short_name: 'Sint Maarten (Dutch part)',
            name: 'Sint Maarten',
        },
        {
            num_code: '703',
            code: 'SK',
            alpha_3_code: 'SVK',
            en_short_name: 'Slovakia',
            name: 'Slovak',
        },
        {
            num_code: '705',
            code: 'SI',
            alpha_3_code: 'SVN',
            en_short_name: 'Slovenia',
            name: 'Slovenian, Slovene',
        },
        {
            num_code: '90',
            code: 'SB',
            alpha_3_code: 'SLB',
            en_short_name: 'Solomon Islands',
            name: 'Solomon Island',
        },
        {
            num_code: '706',
            code: 'SO',
            alpha_3_code: 'SOM',
            en_short_name: 'Somalia',
            name: 'Somali, Somalian',
        },
        {
            num_code: '710',
            code: 'ZA',
            alpha_3_code: 'ZAF',
            en_short_name: 'South Africa',
            name: 'South African',
        },
        {
            num_code: '239',
            code: 'GS',
            alpha_3_code: 'SGS',
            en_short_name: 'South Georgia and the South Sandwich Islands',
            name: 'South Georgia or South Sandwich Islands',
        },
        {
            num_code: '728',
            code: 'SS',
            alpha_3_code: 'SSD',
            en_short_name: 'South Sudan',
            name: 'South Sudanese',
        },
        {
            num_code: '724',
            code: 'ES',
            alpha_3_code: 'ESP',
            en_short_name: 'Spain',
            name: 'Spanish',
        },
        {
            num_code: '144',
            code: 'LK',
            alpha_3_code: 'LKA',
            en_short_name: 'Sri Lanka',
            name: 'Sri Lankan',
        },
        {
            num_code: '729',
            code: 'SD',
            alpha_3_code: 'SDN',
            en_short_name: 'Sudan',
            name: 'Sudanese',
        },
        {
            num_code: '740',
            code: 'SR',
            alpha_3_code: 'SUR',
            en_short_name: 'Suriname',
            name: 'Surinamese',
        },
        {
            num_code: '744',
            code: 'SJ',
            alpha_3_code: 'SJM',
            en_short_name: 'Svalbard and Jan Mayen',
            name: 'Svalbard',
        },
        {
            num_code: '748',
            code: 'SZ',
            alpha_3_code: 'SWZ',
            en_short_name: 'Swaziland',
            name: 'Swazi',
        },
        {
            num_code: '752',
            code: 'SE',
            alpha_3_code: 'SWE',
            en_short_name: 'Sweden',
            name: 'Swedish',
        },
        {
            num_code: '756',
            code: 'CH',
            alpha_3_code: 'CHE',
            en_short_name: 'Switzerland',
            name: 'Swiss',
        },
        {
            num_code: '760',
            code: 'SY',
            alpha_3_code: 'SYR',
            en_short_name: 'Syrian Arab Republic',
            name: 'Syrian',
        },
        {
            num_code: '158',
            code: 'TW',
            alpha_3_code: 'TWN',
            en_short_name: 'Taiwan',
            name: 'Chinese, Taiwanese',
        },
        {
            num_code: '762',
            code: 'TJ',
            alpha_3_code: 'TJK',
            en_short_name: 'Tajikistan',
            name: 'Tajikistani',
        },
        {
            num_code: '834',
            code: 'TZ',
            alpha_3_code: 'TZA',
            en_short_name: 'Tanzania, United Republic of',
            name: 'Tanzanian',
        },
        {
            num_code: '764',
            code: 'TH',
            alpha_3_code: 'THA',
            en_short_name: 'Thailand',
            name: 'Thai',
        },
        {
            num_code: '626',
            code: 'TL',
            alpha_3_code: 'TLS',
            en_short_name: 'Timor-Leste',
            name: 'Timorese',
        },
        {
            num_code: '768',
            code: 'TG',
            alpha_3_code: 'TGO',
            en_short_name: 'Togo',
            name: 'Togolese',
        },
        {
            num_code: '772',
            code: 'TK',
            alpha_3_code: 'TKL',
            en_short_name: 'Tokelau',
            name: 'Tokelauan',
        },
        {
            num_code: '776',
            code: 'TO',
            alpha_3_code: 'TON',
            en_short_name: 'Tonga',
            name: 'Tongan',
        },
        {
            num_code: '780',
            code: 'TT',
            alpha_3_code: 'TTO',
            en_short_name: 'Trinidad and Tobago',
            name: 'Trinidadian or Tobagonian',
        },
        {
            num_code: '788',
            code: 'TN',
            alpha_3_code: 'TUN',
            en_short_name: 'Tunisia',
            name: 'Tunisian',
        },
        {
            num_code: '792',
            code: 'TR',
            alpha_3_code: 'TUR',
            en_short_name: 'Turkey',
            name: 'Turkish',
        },
        {
            num_code: '795',
            code: 'TM',
            alpha_3_code: 'TKM',
            en_short_name: 'Turkmenistan',
            name: 'Turkmen',
        },
        {
            num_code: '796',
            code: 'TC',
            alpha_3_code: 'TCA',
            en_short_name: 'Turks and Caicos Islands',
            name: 'Turks and Caicos Island',
        },
        {
            num_code: '798',
            code: 'TV',
            alpha_3_code: 'TUV',
            en_short_name: 'Tuvalu',
            name: 'Tuvaluan',
        },
        {
            num_code: '800',
            code: 'UG',
            alpha_3_code: 'UGA',
            en_short_name: 'Uganda',
            name: 'Ugandan',
        },
        {
            num_code: '804',
            code: 'UA',
            alpha_3_code: 'UKR',
            en_short_name: 'Ukraine',
            name: 'Ukrainian',
        },
        {
            num_code: '784',
            code: 'AE',
            alpha_3_code: 'ARE',
            en_short_name: 'United Arab Emirates',
            name: 'Emirati, Emirian, Emiri',
        },
        {
            num_code: '826',
            code: 'GB',
            alpha_3_code: 'GBR',
            en_short_name: 'United Kingdom of Great Britain and Northern Ireland',
            name: 'British, UK',
        },
        {
            num_code: '581',
            code: 'UM',
            alpha_3_code: 'UMI',
            en_short_name: 'United States Minor Outlying Islands',
            name: 'American Minor Outlying Islands',
        },
        {
            num_code: '840',
            code: 'US',
            alpha_3_code: 'USA',
            en_short_name: 'United States of America',
            name: 'American',
        },
        {
            num_code: '858',
            code: 'UY',
            alpha_3_code: 'URY',
            en_short_name: 'Uruguay',
            name: 'Uruguayan',
        },
        {
            num_code: '860',
            code: 'UZ',
            alpha_3_code: 'UZB',
            en_short_name: 'Uzbekistan',
            name: 'Uzbekistani, Uzbek',
        },
        {
            num_code: '548',
            code: 'VU',
            alpha_3_code: 'VUT',
            en_short_name: 'Vanuatu',
            name: 'Ni-Vanuatu, Vanuatuan',
        },
        {
            num_code: '862',
            code: 'VE',
            alpha_3_code: 'VEN',
            en_short_name: 'Venezuela (Bolivarian Republic of)',
            name: 'Venezuelan',
        },
        {
            num_code: '704',
            code: 'VN',
            alpha_3_code: 'VNM',
            en_short_name: 'Vietnam',
            name: 'Vietnamese',
        },
        {
            num_code: '92',
            code: 'VG',
            alpha_3_code: 'VGB',
            en_short_name: 'Virgin Islands (British)',
            name: 'British Virgin Island',
        },
        {
            num_code: '850',
            code: 'VI',
            alpha_3_code: 'VIR',
            en_short_name: 'Virgin Islands (U.S.)',
            name: 'U.S. Virgin Island',
        },
        {
            num_code: '876',
            code: 'WF',
            alpha_3_code: 'WLF',
            en_short_name: 'Wallis and Futuna',
            name: 'Wallis and Futuna, Wallisian or Futunan',
        },
        {
            num_code: '732',
            code: 'EH',
            alpha_3_code: 'ESH',
            en_short_name: 'Western Sahara',
            name: 'Sahrawi, Sahrawian, Sahraouian',
        },
        {
            num_code: '887',
            code: 'YE',
            alpha_3_code: 'YEM',
            en_short_name: 'Yemen',
            name: 'Yemeni',
        },
        {
            num_code: '894',
            code: 'ZM',
            alpha_3_code: 'ZMB',
            en_short_name: 'Zambia',
            name: 'Zambian',
        },
        {
            num_code: '716',
            code: 'ZW',
            alpha_3_code: 'ZWE',
            en_short_name: 'Zimbabwe',
            name: 'Zimbabwean',
        },
    ],
};

export const Mappingcodes = {
    BD: 'BDT',
    BE: 'EUR',
    BF: 'XOF',
    BG: 'BGN',
    BA: 'BAM',
    BB: 'BBD',
    WF: 'XPF',
    BL: 'EUR',
    BM: 'BMD',
    BN: 'BND',
    BO: 'BOB',
    BH: 'BHD',
    BI: 'BIF',
    BJ: 'XOF',
    BT: 'BTN',
    JM: 'JMD',
    BV: 'NOK',
    BW: 'BWP',
    WS: 'WST',
    BQ: 'USD',
    BR: 'BRL',
    BS: 'BSD',
    JE: 'GBP',
    BY: 'BYN',
    BZ: 'BZD',
    RU: 'RUB',
    RW: 'RWF',
    RS: 'RSD',
    TL: 'USD',
    RE: 'EUR',
    TM: 'TMT',
    TJ: 'TJS',
    RO: 'RON',
    TK: 'NZD',
    GW: 'XOF',
    GU: 'USD',
    GT: 'GTQ',
    GS: 'GBP',
    GR: 'EUR',
    GQ: 'XAF',
    GP: 'EUR',
    JP: 'JPY',
    GY: 'GYD',
    GG: 'GBP',
    GF: 'EUR',
    GE: 'GEL',
    GD: 'XCD',
    GB: 'GBP',
    GA: 'XAF',
    SV: 'USD',
    GN: 'GNF',
    GM: 'GMD',
    GL: 'DKK',
    GI: 'GIP',
    GH: 'GHS',
    OM: 'OMR',
    TN: 'TND',
    JO: 'JOD',
    HR: 'HRK',
    HT: 'HTG',
    HU: 'HUF',
    HK: 'HKD',
    HN: 'HNL',
    HM: 'AUD',
    VE: 'VEF',
    PR: 'USD',
    PS: 'ILS',
    PW: 'USD',
    PT: 'EUR',
    SJ: 'NOK',
    PY: 'PYG',
    IQ: 'IQD',
    PA: 'PAB',
    PF: 'XPF',
    PG: 'PGK',
    PE: 'PEN',
    PK: 'PKR',
    PH: 'PHP',
    PN: 'NZD',
    PL: 'PLN',
    PM: 'EUR',
    ZM: 'ZMW',
    EH: 'MAD',
    EE: 'EUR',
    EG: 'EGP',
    ZA: 'ZAR',
    EC: 'USD',
    IT: 'EUR',
    VN: 'VND',
    SB: 'SBD',
    ET: 'ETB',
    SO: 'SOS',
    ZW: 'ZWL',
    SA: 'SAR',
    ES: 'EUR',
    ER: 'ERN',
    ME: 'EUR',
    MD: 'MDL',
    MG: 'MGA',
    MF: 'EUR',
    MA: 'MAD',
    MC: 'EUR',
    UZ: 'UZS',
    MM: 'MMK',
    ML: 'XOF',
    MO: 'MOP',
    MN: 'MNT',
    MH: 'USD',
    MK: 'MKD',
    MU: 'MUR',
    MT: 'EUR',
    MW: 'MWK',
    MV: 'MVR',
    MQ: 'EUR',
    MP: 'USD',
    MS: 'XCD',
    MR: 'MRO',
    IM: 'GBP',
    UG: 'UGX',
    TZ: 'TZS',
    MY: 'MYR',
    MX: 'MXN',
    IL: 'ILS',
    FR: 'EUR',
    IO: 'USD',
    SH: 'SHP',
    FI: 'EUR',
    FJ: 'FJD',
    FK: 'FKP',
    FM: 'USD',
    FO: 'DKK',
    NI: 'NIO',
    NL: 'EUR',
    NO: 'NOK',
    NA: 'NAD',
    VU: 'VUV',
    NC: 'XPF',
    NE: 'XOF',
    NF: 'AUD',
    NG: 'NGN',
    NZ: 'NZD',
    NP: 'NPR',
    NR: 'AUD',
    NU: 'NZD',
    CK: 'NZD',
    XK: 'EUR',
    CI: 'XOF',
    CH: 'CHF',
    CO: 'COP',
    CN: 'CNY',
    CM: 'XAF',
    CL: 'CLP',
    CC: 'AUD',
    CA: 'CAD',
    CG: 'XAF',
    CF: 'XAF',
    CD: 'CDF',
    CZ: 'CZK',
    CY: 'EUR',
    CX: 'AUD',
    CR: 'CRC',
    CW: 'ANG',
    CV: 'CVE',
    CU: 'CUP',
    SZ: 'SZL',
    SY: 'SYP',
    SX: 'ANG',
    KG: 'KGS',
    KE: 'KES',
    SS: 'SSP',
    SR: 'SRD',
    KI: 'AUD',
    KH: 'KHR',
    KN: 'XCD',
    KM: 'KMF',
    ST: 'STD',
    SK: 'EUR',
    KR: 'KRW',
    SI: 'EUR',
    KP: 'KPW',
    KW: 'KWD',
    SN: 'XOF',
    SM: 'EUR',
    SL: 'SLL',
    SC: 'SCR',
    KZ: 'KZT',
    KY: 'KYD',
    SG: 'SGD',
    SE: 'SEK',
    SD: 'SDG',
    DO: 'DOP',
    DM: 'XCD',
    DJ: 'DJF',
    DK: 'DKK',
    VG: 'USD',
    DE: 'EUR',
    YE: 'YER',
    DZ: 'DZD',
    US: 'USD',
    UY: 'UYU',
    YT: 'EUR',
    UM: 'USD',
    LB: 'LBP',
    LC: 'XCD',
    LA: 'LAK',
    TV: 'AUD',
    TW: 'TWD',
    TT: 'TTD',
    TR: 'TRY',
    LK: 'LKR',
    LI: 'CHF',
    LV: 'EUR',
    TO: 'TOP',
    LT: 'EUR',
    LU: 'EUR',
    LR: 'LRD',
    LS: 'LSL',
    TH: 'THB',
    TF: 'EUR',
    TG: 'XOF',
    TD: 'XAF',
    TC: 'USD',
    LY: 'LYD',
    VA: 'EUR',
    VC: 'XCD',
    AE: 'AED',
    AD: 'EUR',
    AG: 'XCD',
    AF: 'AFN',
    AI: 'XCD',
    VI: 'USD',
    IS: 'ISK',
    IR: 'IRR',
    AM: 'AMD',
    AL: 'ALL',
    AO: 'AOA',
    AQ: '',
    AS: 'USD',
    AR: 'ARS',
    AU: 'AUD',
    AT: 'EUR',
    AW: 'AWG',
    IN: 'INR',
    AX: 'EUR',
    AZ: 'AZN',
    IE: 'EUR',
    ID: 'IDR',
    UA: 'UAH',
    QA: 'QAR',
    MZ: 'MZN',
}
